import { isDevEnvironment } from '../utils/environment';

const STATIC_CDN_DEV = 'https://static.dev.agendario.com.br';
const STATIC_CDN_PROD = 'https://static.agendario.com.br';

const getCdnBase = () => (isDevEnvironment() ? STATIC_CDN_DEV : STATIC_CDN_PROD);

let cachedManifest = null;

export const resolveUrl = (relativePath) => {
  if (!relativePath) return '';
  if (relativePath.startsWith('http://') || relativePath.startsWith('https://')) return relativePath;
  return getCdnBase() + relativePath;
};

export const getManifest = async () => {
  if (cachedManifest) return cachedManifest;

  const url = `${getCdnBase()}/images/gallery/manifest.json`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Erro ao carregar galeria: ${res.status}`);
  cachedManifest = await res.json();
  return cachedManifest;
};
